var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.canShowNavigation
    ? _c("div", { staticClass: "navigation-main" }, [
        _c(
          "div",
          {
            staticClass: "icon-l",
            class: { ["btn-primary"]: _vm.tabSelected === "list" },
            on: {
              click: function ($event) {
                return _vm.changeTab("list")
              },
            },
          },
          [
            _c("i", { staticClass: "fa-solid fa-list" }),
            _vm._v(
              "\n        " + _vm._s(_vm.$t("dash.posts.nav.list")) + "\n    "
            ),
          ]
        ),
        _c(
          "div",
          {
            staticClass: "icon-l",
            class: { ["btn-primary"]: _vm.tabSelected === "planner" },
            on: {
              click: function ($event) {
                return _vm.changeTab("planner")
              },
            },
          },
          [
            _c("i", { staticClass: "fa-regular fa-calendar" }),
            _vm.tabSelected === "planner"
              ? [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.currentViewType == "timeGridWeek"
                          ? _vm.$t("dash.posts.nav.week")
                          : _vm.$t("dash.posts.nav.month")
                      ) +
                      "\n            "
                  ),
                  _c("i", { staticClass: "fa-solid fa-caret-down" }),
                ]
              : [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("dash.posts.nav.calendar")) +
                      "\n        "
                  ),
                ],
          ],
          2
        ),
        _c(
          "div",
          {
            staticClass: "icon-l",
            class: {
              ["btn-primary"]: _vm.tabSelected === "feed",
              disable: !_vm.isPageInstagramSelected,
            },
            on: {
              click: () => _vm.isPageInstagramSelected && _vm.changeTab("feed"),
            },
          },
          [
            _c("i", { staticClass: "fa-brands fa-instagram" }),
            _vm._v("\n        Feed\n    "),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }